const CopyRight = () => {
  const appDomain = localStorage.getItem('domainName');
  return (
    <div className="copyright-container">
      <span>Copyright &#169; 2022-{new Date().getFullYear()} {appDomain ==='myffl.com' ? 'MYFFL' : 'MasterFFL'}.</span>
      <span> All Rights Reserved</span>
    </div>
  );
};

export default CopyRight;
